import { getFileTypeFromExtension } from './fileExtensionManager';
import { FileType, FileExtensionTypes } from 'owa-group-files-hub-store';

export function IsPreviewSupported(fileType: FileType, fileExtension: string): boolean {
    if (!fileExtension || !fileType) {
        return false;
    }

    // TODO add more extensions/file type when we start supporting them for preview
    // PDF support in WAC is getting deprected. we need to still have the below check for now.
    if (fileType == FileType.SharePointFile) {
        const fileExtensionType = getFileTypeFromExtension(fileExtension);
        return fileExtensionType != FileExtensionTypes.Others;
    }

    if (fileType == FileType.ClassicAttachment || fileType == FileType.CloudAttachment) {
        return true;
    }

    return false;
}
